import * as z from "zod";
import { deleteSkillFile as deleteFile } from "../skillFiles";
import { mutator } from "./mutator";

export const deleteSkillFileSchema = z.object({
  skillId: z.string(),
  path: z.string(),
});

export const deleteSkillFile = mutator({
  schema: deleteSkillFileSchema,
  resolve: {
    skill: { kind: "skill", from: "skillId" },
  },
  permissions: [
    {
      permission: "skill:write",
      scopeId: ({ args }) => args.skill.id,
    },
  ],
  fn: async ({ tx, args: { skill, path } }) => {
    await deleteFile(tx, skill.id, path);
  },
});
